const order = {
  path: 'order',
  component: resolve => require(['@/pages/admin/recharge/order'], resolve)
}

export default order
